import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import ProgressBar from "./components/ProgressBar";

function App() {
  return (
    <div>
      <ProgressBar />
      <Main />
    </div>
  );
}

export default App;
